import { RuleModel } from '../../../../types';
import { getRulesEngineFormDefaultValues } from './rules-engine-form-utils';

const getDefaults = (features: Record<string, boolean> | null) =>
  getRulesEngineFormDefaultValues({
    pageMode: 'create',
    loggedInUser: 'system',
    allPolicies: undefined,
    features,
  });

export const getRuleTemplates = (
  features: Record<string, boolean> | null
): Partial<RuleModel>[] => {
  const defaultValues = getDefaults(features);
  const defaultBasicInfo = defaultValues.basicInfo;
  const defaultTriggerInfo = defaultValues.triggerInfo;
  const defaultActionInfo = defaultValues.actionInfo;

  return [
    {
      id: 1,
      basicInfo: {
        ...defaultBasicInfo,
        ruleName: 'New User Creation',
        description: 'Send new users an email',
      },
      triggerInfo: {
        ...defaultTriggerInfo,
        occursEverytime: true,
        triggerGroup: 'admin',
        triggerEvent: 'CREATE_USER',
        triggerOrgSources: ['/'],
      },
      actionInfo: {
        ...defaultActionInfo,
        actionTodo: ['sendEmailTemplate'],
      },
    },
    {
      id: 2,
      allSource: true,
      basicInfo: {
        ...defaultBasicInfo,
        ruleName: 'Calendar Event Restriction',
        description: 'Admin notified when event is created.',
      },
      triggerInfo: {
        ...defaultTriggerInfo,
        occursEverytime: true,
        triggerGroup: 'calendar',
        triggerEvent: 'create_event',
      },
      actionInfo: {
        ...defaultActionInfo,
        actionTodo: ['limitOccurrences'],
        occurrenceLimit: 10,
      },
    },
    {
      id: 3,
      basicInfo: {
        ...defaultBasicInfo,
        ruleName: 'Deletion of Docs in Shared Drives',
        description:
          'Get notified when more than X files have been deleted by a user',
      },
      triggerInfo: {
        ...defaultTriggerInfo,
        occursEverytime: false,
        triggerThreshold: 10,
        triggerGroup: 'drive',
        triggerEvent: 'delete',
        triggerOrgSources: ['/'],
      },
      actionInfo: {
        ...defaultActionInfo,
        actionTodo: ['sendEmail'],
      },
    },
    {
      id: 4,
      basicInfo: {
        ...defaultBasicInfo,
        ruleName: 'Group Membership Is Low',
        description: 'Get notified and delete a Group when membership is < 5',
      },
      triggerInfo: {
        ...defaultTriggerInfo,
        occursEverytime: true,
        triggerGroup: 'admin',
        triggerEvent: 'UPDATE_GROUP_MEMBER',
        triggerOrgSources: ['/'],
      },
      actionInfo: {
        ...defaultActionInfo,
        actionTodo: ['sendEmail', 'deleteGroup'],
      },
      groupFilter: {
        hasMemberCountFilter: true,
        memberCountOperator: 'lessThan',
        memberCount: 5,
      },
    },
  ];
};
